<app-loading [(ativo)]="ativo" text="Estamos carregando suas informações. Vale a pena aguardar!"></app-loading>

<div *ngIf="executar" [hidden]="ativo" class="background-squircles">
  <div class="container">
    <app-nav-bar previousPage="Conheça seus direitos" previousPath="/conheca-seus-direitos" page="Acesse seus dados">
    </app-nav-bar>

    <h1 class="show-mobile-only">Acesse seus dados</h1>


    <app-protocolo></app-protocolo>

    <p class="hidden-mobile disclaimertop">Os dados constantes neste Relatório podem ser utilizados pela Serasa
      Experian, clientes e parceiros em suas soluções de proteção do crédito, prevenção a fraudes, aprimoramento da
      qualidade de dados, segmentações de audiências, análise de potencial de mercado e criação de modelos e perfis
      comportamentais.</p>

    <div class="row divider">
      <img class="mr-2" src="assets/img-analitico/icon-action-round-supervisor_account.svg" alt="">
      <strong class="pt-1">Informações pessoais</strong>
    </div>

    <app-informacoes-cadastrais (emiteLoadingEvento)="carregamentoTela($event)">
    </app-informacoes-cadastrais>

  </div>

  <div class="container my-3">

    <div class="row divider mt-5">
      <img class="mr-2" src="assets/img-analitico/icon-communication-round-business.svg" alt="">
      <strong class="pt-1">Participações societárias</strong>
    </div>

    <app-participacao-societaria (emiteLoadingEvento)="carregamentoTela($event)">
    </app-participacao-societaria>


    <div class="row divider mt-5">
      <img class="mr-2" src="assets/img-analitico/icon-editor-round-round-monetization_on.svg" alt="">
      <strong class="pt-1">Dívidas pendentes</strong>
    </div>


    <m-expansion-panel [id]="'id-accordion-avisos-dividas'" [title]="'Avisos de Dívidas'"
      [active]="larguraEhSuperiorMin">
      <app-bloco-avisos-dividas-serasa></app-bloco-avisos-dividas-serasa>
    </m-expansion-panel>

    <app-bloco-dividas-serasa (emiteLoadingEvento)="carregamentoTela($event)"></app-bloco-dividas-serasa>


    <m-expansion-panel [id]="'id-accordion-dividas-publicas'"
      [title]="'Dívidas públicas pendentes ('+totalDividasGerais+')'" [active]="larguraEhSuperiorMin">
      <app-bloco-dividas-acoes-judiciais (emiteLoadingEvento)="carregamentoTela($event)"
        (totalizadorAcoesJudiciais)="getTotalDividasAcoesJudiciais($event)">
      </app-bloco-dividas-acoes-judiciais>

      <app-bloco-dividas-protestos (emiteLoadingEvento)="carregamentoTela($event)"
        (totalizadorDividasProtestos)="getTotalDividasProtestos($event)">
      </app-bloco-dividas-protestos>

      <app-bloco-dividas-cheque-sem-fundo (emiteLoadingEvento)="carregamentoTela($event)"
        (totalizadorDividasChequeSemFundo)="getTotalDividasChequeSemFundo($event)">
      </app-bloco-dividas-cheque-sem-fundo>

      <app-bloco-dividas-participacao-falencia (emiteLoadingEvento)="carregamentoTela($event)"
        (totalizadorDividasParticipacaoFalencia)="getTotalDividasParticipacaoFalencia($event)">
      </app-bloco-dividas-participacao-falencia>

    </m-expansion-panel>


    <app-bloco-dividas-parceiros (emiteLoadingEvento)="carregamentoTela($event)"></app-bloco-dividas-parceiros>

    <div class="row divider">
      <img class="mr-2" src="assets/img-analitico/icon-communication-round-list_alt.svg" alt="">
      <strong class="pt-1">Histórico de crédito</strong>
    </div>

    <app-bloco-dividas-regularizadas-serasa (emiteLoadingEvento)="carregamentoTela($event)">
    </app-bloco-dividas-regularizadas-serasa>


    <m-expansion-panel [id]="'id-accordion-hisCredito-infoPositivas'"
      [title]="'Dívidas públicas regularizadas ('+totalDividasPublicasResolvidas+')'" [active]="larguraEhSuperiorMin">
      <app-bloco-dividas-regularizadas-acoes-judiciais (emiteLoadingEvento)="carregamentoTela($event)"
        (totalizadorRegularizadasAcoesJudiciais)="getTotalDividasRegularizadasAcoesJudiciais($event)">
      </app-bloco-dividas-regularizadas-acoes-judiciais>

      <app-bloco-dividas-regularizadas-protestos (emiteLoadingEvento)="carregamentoTela($event)"
        (totalizadorRegularizadasProtestos)="getTotalDividasRegularizadasAcoesProtestos($event)">
      </app-bloco-dividas-regularizadas-protestos>

      <app-bloco-dividas-regularizadas-cheque-sem-fundos (emiteLoadingEvento)="carregamentoTela($event)"
        (totalizadorRegularizadasChequesSemFundos)="getTotalDividasRegularizadasAcoesChequesSemFundos($event)">
      </app-bloco-dividas-regularizadas-cheque-sem-fundos>

    </m-expansion-panel>

    <div class="col">
      <app-alert [id]="'hisCredito-mensagem'" [tipo]="'info'">
        Essas informações referem-se ao histórico de dívidas informadas à Serasa Experian nos últimos 05 anos e que não
        mais estão ativas no cadastro de inadimplentes. Tais informações são visualizadas apenas por você, uma vez que os
        clientes e parceiros só podem visualizar as dívidas ativas no cadastro de inadimplentes.
      </app-alert>
    </div>

    <app-bloco-dividas-regularizadas-parceiros (emiteLoadingEvento)="carregamentoTela($event)">
    </app-bloco-dividas-regularizadas-parceiros>

    <m-expansion-panel [id]="'id-accordion-hisCredito-infoPositivas'"
      [title]="'Informações positivas ('+totalInformacaoPositivo+')'" [active]="larguraEhSuperiorMin">
      <app-bloco-informacoes-positivas (emiteLoadingEvento)="carregamentoTela($event)"
        (totalizadorInfoPositivo)="getTotalInformacoesPositivo($event)"
        (mensagemPositivo)="getMensagemPositivoPositivo($event)">
      </app-bloco-informacoes-positivas>

      <div id="id-div-hisCredito" *ngIf="listaServicoFalha.includes('info-positivo') || totalInformacaoPositivo == 0">
        {{mensagemPositivo}}
      </div>

      <app-alert [id]="'hisCredito-mensagem'" [tipo]="'info'">
        As informações acima referem-se ao histórico de informações positivas enviadas pelas empresas que você possui
        relação creditícia, e reúnem contratos como empréstimos, financiamentos, cartão de crédito, pagos ou em
        andamento dos últimos 12 meses mais o mês atual. Tais informações são visualizadas apenas por você, uma vez que
        clientes e parceiros só podem visualizar essas informações detalhadas caso você autorize.
      </app-alert>
    </m-expansion-panel>

    <div class="row divider">
      <img class="mr-2" src="assets/img-analitico/icon-action-round-find_in_page.svg" alt="">
      <strong class="pt-1">Histórico de consultas</strong>
    </div>

    <app-consultas-serasa (emiteLoadingEvento)="carregamentoTela($event)">
    </app-consultas-serasa>

    <app-consultas-parceiros (emiteLoadingEvento)="carregamentoTela($event)">
    </app-consultas-parceiros>

    <app-consulta-serasa-lock-unlock (emiteLoadingEvento)="carregamentoTela($event)">
    </app-consulta-serasa-lock-unlock>


    <app-bloco-nota-credito (emiteLoadingEvento)="carregamentoTela($event)"></app-bloco-nota-credito>

    <p class="texto-final-pagina">
      Todos os dados são armazenados em ambiente seguro e possuem prazo de retenção e de descarte determinados de acordo
      com a legislação aplicável, condições contratuais e Políticas Internas do grupo Experian.  Serasa S.A. com sede na
      Av. das Nações Unidas, 14401 – Torre C-1, Parque da Cidade – conj. 191 a 242 –19º a 24º andares, São Paulo/SP,
      inscrita no CNPJ/MF sob o nº 62.173.620/0001-80.
    </p>
    <app-cards-footer *ngIf="executar" [hidden]="ativo"></app-cards-footer>

  </div>
</div>


<app-footer-lgpd></app-footer-lgpd>
<app-modal-sidebar></app-modal-sidebar>
